// src/components/ui/Button.jsx
// Использование:
//   <Button>Текст</Button>
//   <Button variant="secondary">Отмена</Button>
//   <Button variant="danger">Удалить</Button>
//   <Button variant="success">Готово</Button>
//   <Button variant="ghost">Ссылка</Button>
//   <Button variant="icon" onClick={onClose}><X size={18} /></Button>
//   <Button loading>Сохранение...</Button>
//   <Button icon={<Send size={14} />}>Отправить</Button>
//   <Button size="sm" variant="secondary">Маленькая</Button>

import React from 'react';
import { Loader2 } from 'lucide-react';

const variants = {
  primary:   'bg-brand-accent hover:bg-brand-accent-hover text-gray-900 shadow-xl shadow-brand-accent/30',
  secondary: 'border border-gray-200 text-gray-400 hover:text-gray-900 hover:bg-gray-100',
  danger:    'bg-brand-danger border border-brand-danger-border text-brand-danger-text hover:bg-red-500/20',
  ghost:     'text-gray-400 hover:text-gray-900 hover:bg-gray-100',
  success:   'bg-emerald-600 hover:bg-emerald-500 text-white border border-emerald-700', // добавлен: зелёная кнопка для успешных действий (закрыть после подписания, подтверждение)
  icon:      'text-gray-400 hover:text-gray-900 hover:bg-gray-100 border border-transparent hover:border-gray-200', // добавлен: квадратная иконочная кнопка без текста (закрыть модалку, копировать, toggle)
};

const sizes = {
  sm: 'px-4 py-2 text-[9px]',
  md: 'px-6 py-3 text-[10px]',
  lg: 'px-8 py-4 text-[10px]',
  xl: 'px-10 py-5 text-[11px]',
};

export const Button = ({
  children,
  variant = 'primary',
  size = 'lg',
  loading = false,
  disabled = false,
  icon = null,
  onClick,
  className = '',
  type = 'button',
}) => {
  // variant="icon" игнорирует size — квадратный padding, размер задаётся через className
  const sizeClass = variant === 'icon' ? 'p-2' : (sizes[size] ?? sizes.lg);

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center gap-2
        rounded-md font-black uppercase tracking-widest
        transition-all
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant] ?? variants.primary}
        ${sizeClass}
        ${className}
      `}
    >
      <div className="relative flex items-center justify-center gap-2">
        {loading ? (
          <Loader2 size={14} className="animate-spin" />
        ) : (
          icon && icon
        )}
        <span className={loading ? 'opacity-70' : ''}>{children}</span>
      </div>
    </button>
  );
};